<div class="container">
    <img src="assets/city.png" class="back-image"/>
    <div class="float-blurb">
        <span>The mission of Cranberry Queues is to deliver software that is both reliable and astounding.</span>
        <br>
        <span>Since our founding in April 2020, Cranberry Queues has maintained multiple websites and an application on the Apple App Store. The company began as a product idea, manifested and refined by four engineers. We believe that everyone deserves to be heard, and therefore everyone deserves great software.</span>
    </div>
</div>
